import styled, { css } from 'styled-components';

import type { ICartTheme } from '@/shared/themes/types';

export const Wrapper = styled.div`
  height: max-content;
`;
export const StringNumberOfOrder = styled.h3`
  ${({ theme }: { theme: ICartTheme }) => css`
    font-size: ${theme.fontSizes.large};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.defaultDarkColor};
    margin: 0;
  `};
`;

export const Hr = styled.hr`
  ${({ isShow }: { isShow: boolean }) => css`
    display: ${isShow ? 'block' : 'none'};
    margin: 61px 0 32px 0;
    border-top: 1px solid #333;
  `};
`;

export const WrapperBilling = styled.div`
  ${({ theme }: { theme: ICartTheme }) => css`
    margin: 32px 0 0 0;
    text-align: end;

    ${theme.media.tablet} {
      margin: 32px 16px 0 16px;
    }
  `}
`;

export const WrapperButtonBilling = styled.div`
  ${({ theme }: { theme: ICartTheme }) => css`
    margin-top: 32px;
    text-align: center;

    ${theme.media.tablet} {
      text-align: end;
    }
  `}
`;

export const BoxBilling = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RowBilling = styled.div`
  height: fit-content;
  display: flex;
  overflow: auto;
  flex-direction: row;
  justify-content: flex-end;
  -ms-flex-pack: end;
  -webkit-box-pack: end;
  gap: 32px;
  overflow: hidden;
`;

export const NamePosition = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.normal};
    line-height: 1.5;
    color: ${theme.defaultDarkColor};
  `};
`;

export const PricePostion = styled.div`
  ${({ theme, width = 50 }: { theme: ICartTheme; width: number }) => css`
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.large};
    line-height: 1.5;
    color: ${theme.defaultDarkColor};
    width: ${width}px;
    box-sizing: border-box;
  `};
`;

export const Split = styled.div`
  ${({ theme }) => css`
    border-top: solid 1px ${theme.warmGrey};
    margin-top: 32px;
  `};
`;

export const ButtonCheckOut = styled.button`
  ${({ theme }) => css`
    height: 40px;
    padding: 8px 24px;
    border: 2px solid;
    border-radius: 4px;
    background-color: ${theme.defaultPrimaryColor};
    border-color: ${theme.defaultPrimaryColor};
  `};
`;

export const SpanTextButton = styled.span`
  ${({ theme }: { theme: ICartTheme }) => css`
    font-size: 16px;
    font-weight: ${theme.fontWeight.large};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #ffffff;
  `};
`;

type DivRowTable = {
  width?: string;
  float?: string;
};

export const TableOrder = styled.table`
  ${({ theme }) => css`
    margin: 0;
    height: max-content;
    width: auto;
    margin-top: 16px;

    ${theme.media.tablet} {
      margin: 16px;
    }
  `}
`;
export const THeadOrder = styled.thead`
  height: 19px;
  width: max-content;
`;

export const TBodyOrder = styled.tbody`
  height: max-content;
  width: max-content;
`;

export const TR = styled.tr`
  width: inherit;
  background: #ffffff !important;
`;
export const TH = styled.th`
  padding: 0;
  vertical-align: text-top;
`;
export const THQTY = styled(TH)`
  width: 4%;
`;
export const TD = styled.td`
  padding: 0;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;

export const DivRowTable = styled.div<DivRowTable>`
  ${({ theme }) => css`
    ${theme.media.desktop} {
      max-width: max-content;
    }
    max-width: 180px;
    font-size: ${theme.fontSizes.large};
    font-weight: ${theme.fontWeight.large};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-right: 21px;
    margin-top: 8px;
  `}
`;

export const DivRowModifires = styled.div<DivRowTable>`
  ${({ theme }) => css`
    ${theme.media.desktop} {
      max-width: max-content;
    }
    max-width: 180px;
    min-height: 24px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: ${theme.defaultDarkColor};
    margin-top: 2px;
  `}
`;

export const DivRowTableQTY = styled(DivRowTable)`
  max-width: 30px;
  text-align: center;
`;
export const HeaderDivRowTable = styled(DivRowTable)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.small};
    max-width: 30px;
    margin-top: 0;
  `}
`;

export const DivRowPrice = styled.div<DivRowTable>`
  ${({ theme, float = 'right' }) => css`
    float: ${float};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.large};
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 8px;
    text-align: right;
  `};
  width: ${(props) => (props.width ? props.width : '80px')};
`;

export const RowPrice = styled.div<DivRowTable>`
  ${({ theme }) => css`
    color: ${theme.defaultDarkColor};
    float: right;
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.large};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: right;
  `}
`;

export const RowEachPrice = styled.div<DivRowTable>`
  ${({ theme }) => css`
    color: ${theme.defaultDarkColor};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.normal};
    line-height: 1.5;
    text-align: right;
    white-space: pre;
  `}
`;

export const DIVContainer = styled(DivRowTable)`
  display: block;
  width: ${(props) => (props.width ? props.width : '180px')};
`;

export const ButtonOrder = styled.button`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.normal};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: right;
    color: ${theme.defaultPrimaryColor};
    background: none;
    border: none;
    padding: 0px 19px 0px 0px;
  `}
`;

export const WrapperPrice = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PickUPOrderComponent = styled.div`
  border-radius: 4px;
  border: solid 1px #ccc;
  background-color: #f7f7f7;
`;
export const WrapperPickUpLocationComponent = styled.div`
  ${({ theme }) => css`
    display: flex;

    margin: 16px;
    justify-content: space-between;

    ${theme.media.tablet} {
      height: 24px;
      margin: 24px 32px;
    }
  `}
`;

export const SpanPickUp = styled.span`
  ${() => css`
    font-size: 18px;
    font-weight: 600;
    line-height: 1.33;
    color: #000000;
  `}
`;

export const SpanPickUpWall = styled(SpanPickUp)`
  ${({ theme }) => css`
    display: none;
    ${theme.media.tablet} {
      display: block;
    }
  `}
`;

export const ButtonChangePickUp = styled.button`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    color: ${theme.defaultPrimaryColor};
    background: none;
    border: none;
    height: min-content;
  `}
`;
export const RowPickUp = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    ${theme.media.tablet} {
      flex-direction: row;
      gap: 16px;
    }
  `}
`;
